import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { MeProvider } from '../contexts/MeContext';
import { InventoryProvider } from '../contexts/InventoryContext';
import { SystemMessageProvider } from '../contexts/SystemMessageContext';
import { DashboardLayout } from './DashboardLayout';
import { SystemMessageModal } from './ui/SystemMessageModal';
import { IOSInstallBanner } from './IOSInstallBanner';

export function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-deep-blue-900">
        <div className="font-pixel text-neon-blue-400">
          Loading...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <MeProvider>
      <SystemMessageProvider>
        <InventoryProvider>
          <DashboardLayout />
        </InventoryProvider>
        <SystemMessageModal />
        <IOSInstallBanner />
      </SystemMessageProvider>
    </MeProvider>
  );
}
